module.exports = __webpack_public_path__ + "assets/retina_LozengeDetailed.2c9b97f5e98c18e100f52fecc76c45c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LozengeDetailed.png
// module id = 691
// module chunks = 0